(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (() => {
    const normalizeHeading = (value) => value.replace(/\s+/g, ' ').trim().toLowerCase();

    const initializeFaq = (content) => {
      if (!content || content.querySelector('[data-calinfi-article-faq]')) return;

      const faqHeading = Array.from(content.querySelectorAll(':scope > h2')).find((heading) => {
        return normalizeHeading(heading.textContent) === 'frequently asked questions';
      });

      if (!faqHeading) return;

      const questions = [];
      let current = faqHeading.nextElementSibling;

      while (current && current.tagName !== 'H2') {
        if (current.tagName !== 'H3') {
          current = current.nextElementSibling;
          continue;
        }

        const question = current;
        const answerNodes = [];
        current = current.nextElementSibling;

        while (current && current.tagName !== 'H2' && current.tagName !== 'H3') {
          const answerNode = current;
          current = current.nextElementSibling;
          answerNodes.push(answerNode);
        }

        questions.push({ question, answerNodes });
      }

      if (questions.length === 0) return;

      const faq = document.createElement('section');
      const list = document.createElement('div');
      const headingId = faqHeading.id || `CalinfiArticleFaq-${Math.random().toString(36).slice(2, 9)}`;

      faq.dataset.calinfiArticleFaq = '';
      faq.className = 'calinfi-article-faq';
      faq.setAttribute('aria-labelledby', headingId);
      list.className = 'calinfi-article-faq__list';
      faqHeading.id = headingId;
      faqHeading.classList.add('calinfi-article-faq__heading');
      faqHeading.parentNode.insertBefore(faq, faqHeading);
      faq.append(faqHeading, list);

      questions.forEach(({ question, answerNodes }) => {
        const item = document.createElement('details');
        const summary = document.createElement('summary');
        const label = document.createElement('span');
        const icon = document.createElement('span');
        const answer = document.createElement('div');

        item.className = 'calinfi-article-faq__item';
        summary.className = 'calinfi-article-faq__question';
        label.textContent = question.textContent.trim();
        icon.className = 'calinfi-article-faq__icon';
        icon.setAttribute('aria-hidden', 'true');
        answer.className = 'calinfi-article-faq__answer';
        answerNodes.forEach((node) => answer.append(node));
        summary.append(label, icon);
        item.append(summary, answer);
        list.append(item);
        question.remove();
      });
    };

    const initializeArticle = (root) => {
      if (!root || root.dataset.articleInitialized === 'true') return;

      root.dataset.articleInitialized = 'true';

      initializeFaq(root.querySelector('[data-calinfi-article-content]'));

      const related = root.querySelector('[data-calinfi-related]');
      if (!related) return;

      const viewport = related.querySelector('[data-related-viewport]');
      const cards = Array.from(related.querySelectorAll('[data-related-card]'));
      const previousButton = related.querySelector('[data-related-prev]');
      const nextButton = related.querySelector('[data-related-next]');

      if (!viewport || cards.length === 0) return;

      const cardCenter = (card) => card.offsetLeft - (viewport.clientWidth - card.offsetWidth) / 2;

      const activeCard = () => {
        const viewportCenter = viewport.scrollLeft + viewport.clientWidth / 2;
        return cards.reduce((closest, card) => {
          const cardMiddle = card.offsetLeft + card.offsetWidth / 2;
          const distance = Math.abs(cardMiddle - viewportCenter);
          return distance < closest.distance ? { card, distance } : closest;
        }, { card: cards[0], distance: Number.POSITIVE_INFINITY }).card;
      };

      const updateState = () => {
        const current = activeCard();
        const currentIndex = cards.indexOf(current);

        cards.forEach((card) => card.classList.toggle('is-active', card === current));

        if (previousButton) previousButton.disabled = currentIndex <= 0;
        if (nextButton) nextButton.disabled = currentIndex >= cards.length - 1;
      };

      const scrollToIndex = (index, behavior = 'smooth') => {
        const normalizedIndex = Math.max(0, Math.min(index, cards.length - 1));
        viewport.scrollTo({ left: cardCenter(cards[normalizedIndex]), behavior });
      };

      previousButton?.addEventListener('click', () => {
        scrollToIndex(cards.indexOf(activeCard()) - 1);
      });

      nextButton?.addEventListener('click', () => {
        scrollToIndex(cards.indexOf(activeCard()) + 1);
      });

      viewport.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        scrollToIndex(cards.indexOf(activeCard()) + direction);
      });

      let updateFrame;
      viewport.addEventListener('scroll', () => {
        window.cancelAnimationFrame(updateFrame);
        updateFrame = window.requestAnimationFrame(updateState);
      }, { passive: true });

      window.addEventListener('resize', updateState);

      const initialIndex = cards.length >= 3 && window.innerWidth >= 990 ? 1 : 0;
      window.requestAnimationFrame(() => {
        scrollToIndex(initialIndex, 'auto');
        updateState();
      });
    };

    document.querySelectorAll('[data-calinfi-article]').forEach(initializeArticle);

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches?.('[data-calinfi-article]')
        ? event.target
        : event.target.querySelector?.('[data-calinfi-article]');
      initializeArticle(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
